export const BASE_API = process.env.REACT_APP_BASE_API as string;
const params = new URLSearchParams(document.location.search);
export const APP_ID = Number(params.get('vk_app_id'));
